import {
  SET_CLASS_COUNT,
  SET_CLASSES_DATA,
  SET_CLASS_DATA,
} from "../../actions/types/types";

const initState = {
  classes: [],
  classData: {},
  classCount: 0,
  classMembers: [],
  classInfoModalOpen: false,
  classEditModal: false,
  selectedClassForEdit: undefined,
  selectedClassForCancel: undefined,
  classCancelModal: false,
  cancelBookingModal: false,
  settlePaymentModal: false,
  addToBookingListModal: false,
  classesForWeek: [],
  selectedClassId: null,
  memberSupportedPackagesForClass: null,
  classBookings: [],
  addingSaleFromClassInfo: false,
  appointments: [],
  bookAppointmentModal: false,
  appointmentsBookings: [],
  singleAppointment: null,
  appointmentsForWeek: [],
  allWeeklySchedule: [],
  forceAddModalOpen: false,
  allClassesModalOpen: false,
  deductPackageModal: false,
  deductPackageInfo: {
    service: null,
    bookingId: null,
    memberId: null,
  },
};

const ClassReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_CLASSES_DATA:
      return {
        ...state,
        classes: action.payload.data,
      };
    case "SET_SELECTED_CLASS_ID":
      return {
        ...state,
        selectedClassId: action.payload.data,
      };
    case "SET_MEMBER_SUPPORTED_PACKAGES_FOR_CLASS":
      return {
        ...state,
        memberSupportedPackagesForClass: action.payload.data,
      };
    case SET_CLASS_DATA:
      return {
        ...state,
        classData: action.payload.data,
      };
    case SET_CLASS_COUNT:
      return {
        ...state,
        classCount: action.payload.data,
      };
    case "SET_CLASS_MEMBERS":
      return {
        ...state,
        classMembers: action.payload.data,
      };
    case "SET_CLASSES_FOR_WEEK":
      return {
        ...state,
        classesForWeek: action.payload.data,
      };
    case "TOGGLE_INFO_CLASS_MODAL_OPEN":
      return {
        ...state,
        classInfoModalOpen: !state.classInfoModalOpen,
      };
    case "TOGGLE_EDIT_CLASS_MODAL":
      return {
        ...state,
        selectedClassForEdit: action.payload.data,
        classEditModal: !state.classEditModal,
      };
    case "TOGGLE_CLASS_CANCEL_MODAL":
      return {
        ...state,
        selectedClassForCancel: action.payload.data,
        classCancelModal: !state.classCancelModal,
      };
    case "TOGGLE_BOOKING_CANCEL_MODAL":
      return {
        ...state,
        cancelBookingModal: !state.cancelBookingModal,
      };
    case "TOGGLE_ADDING_SALE_FROM_CLASS_INFO":
      return {
        ...state,
        addingSaleFromClassInfo: action.payload.data,
      };
    case "TOGGLE_SETTLE_PAYMENT_MODAL":
      return {
        ...state,
        settlePaymentModal: !state.settlePaymentModal,
      };
    case "DEDUCT_PACKAGE_INFO":
      return {
        ...state,
        deductPackageInfo: action.payload.data,
      };

    case "TOGGLE_DEDUCT_PACKAGE_MODAL":
      return {
        ...state,
        deductPackageModal: action.payload.data,
      };

    case "TOGGLE_ADD_TO_BOOKING_LIST_MODAL":
      return {
        ...state,
        addToBookingListModal: !state.addToBookingListModal,
      };
    case "TOGGLE_BOOK_APPOINTMENT_MODAL":
      return {
        ...state,
        bookAppointmentModal: !state.bookAppointmentModal,
      };
    case "SET_APPOINTMENTS":
      return {
        ...state,
        appointments: action.payload.data,
      };
    case "SET_SINGLE_APPOINTMENT":
      return {
        ...state,
        singleAppointment: action.payload.data,
      };
    case "SET_APPOINTMENTS_BOOKINGS":
      return {
        ...state,
        appointmentsBookings: action.payload.data,
      };
    case "SET_ALL_WEEKLY_SCHEDULE":
      return {
        ...state,
        allWeeklySchedule: action.payload.data,
      };
    case "SET_APPOINTMENTS_FOR_WEEK":
      return {
        ...state,
        appointmentsForWeek: action.payload.data,
      };
    case "SET_FORCE_ADD_MODAL_OPEN":
      return {
        ...state,
        forceAddModalOpen: action.payload.data,
      };
    case "SET_ALL_CLASSES_MODAL_OPEN":
      return {
        ...state,
        allClassesModalOpen: action.payload.data,
      };
    case "RESET_APPOINTMENTS_BOOKINGS":
      return {
        ...state,
        appointmentsBookings: [],
      };
    default:
      return { ...state };
  }
};

export default ClassReducer;
